import { useState } from "react";
import { Check, Flag } from "lucide-react";
import { formatGal, formatToEighths } from "@/lib/tank";
import { FINGERPRINTS_CHECKED, rankByGpi } from "@/lib/zones";
import { fromShown, METRIC } from "@/lib/units";

function FpCard({ f, best, active, onUse, t }) {
  return (
    <div className={`fp-card ${best ? "fp-best" : ""}`} data-testid={`fp-${f.id}`}>
      <b>{t(f.name)}</b>
      <div className="fp-grid mono">
        <span>{t("True ID")}</span><span>{f.idLabel}</span>
        <span>{t("Max")}</span><span>{formatGal(f.max)} gal</span>
        <span>{t("90% fill")}</span><span>{formatGal(f.max * 0.9)} gal · {formatToEighths(f.calcH90)}</span>
        <span>{t("Belly GPI")}</span><span>{Math.round(f.calcGpi)} gal/in</span>
        <span>{t("Stick")}</span><span>{t(f.stick === 15 ? "15' folding" : "12' standard")}</span>
      </div>
      {f.flags.length > 0 && (
        <div className="fp-flag" data-testid={`fp-${f.id}-flag`}><Flag size={13} />
          {t("Your table: {h} at 90%, {g} gal/in. Shape math differs, so trust the store's chart.", { h: `${f.h90}"`, g: f.gpi })}</div>
      )}
      <button type="button" className={active ? "primary-btn" : "ghost-btn"} onClick={onUse} data-testid={`fp-${f.id}-use`}>
        {active && <Check size={15} />}{t(active ? "On the chart" : "Use this tank")}</button>
    </div>
  );
}

export function Fingerprints({ s, patch, t }) {
  const [gpiText, setGpiText] = useState("");
  const typed = parseFloat(gpiText);
  const gpi = Number.isFinite(typed) && typed > 0 ? (METRIC ? (typed * fromShown(1, "gal")) / fromShown(1, "in") : typed) : 0;
  const list = gpi ? rankByGpi(gpi) : FINGERPRINTS_CHECKED;
  return (
    <div className="fp-wrap" data-testid="fp-section">
      <div className="card-sub">{t("Unknown tank? Drop some fuel in the belly, then divide gallons dropped by inches risen. That's the belly GPI. It also catches an ATG set up with the wrong chart.")}</div>
      <label className="field"><span className="label">{t("Measured belly gal per inch")}</span>
        <input className="text-input" inputMode="decimal" value={gpiText} placeholder="133" onChange={(e) => setGpiText(e.target.value.replace(/[^\d.]/g, ""))} data-testid="fp-gpi-input" /></label>
      {gpi > 0 && <div className="scan-message tone-safe" data-testid="fp-match">{t("Closest: {n} ({p}% off)", { n: t(list[0].name), p: Math.round(list[0].off * 100) })}</div>}
      <div className="fp-row">
        {list.map((f, i) => (
          <FpCard key={f.id} f={f} best={gpi > 0 && i === 0} t={t}
            active={s.capacity === f.max && Math.abs(s.diameter - f.d) < 0.01 && s.ends === f.ends}
            onUse={() => patch({ capacity: f.max, diameter: f.d, ends: f.ends })} />
        ))}
      </div>
    </div>
  );
}
